/**
 * @generated SignedSource<<f0d26fb2a80934fb79dfa5948cc12d5a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebarItemInfo_buyer$data = {
  readonly canShowSellerName: boolean | null;
  readonly " $fragmentType": "CheckoutSidebarItemInfo_buyer";
};
export type CheckoutSidebarItemInfo_buyer$key = {
  readonly " $data"?: CheckoutSidebarItemInfo_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarItemInfo_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebarItemInfo_buyer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canShowSellerName",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "4969fa73f09fa1bacd93373ade811934";

export default node;
